import * as yup from "yup"
export const openTicketSchema = yup.object().shape({
  description: yup.string().required("Description field is required"),
})
